import {
    PENDING_PAYMENTS_DETAILS_START,
    PENDING_PAYMENTS_DETAILS_SUCCESS,
    PENDING_PAYMENTS_DETAILS_ERROR,
    COMPLETED_PAYMENTS_DETAILS_START,
    COMPLETED_PAYMENTS_DETAILS_SUCCESS,
    COMPLETED_PAYMENTS_DETAILS_ERROR,
    CANCEL_CHARGE_PAYMENTS_DETAILS_START,
    CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS,
    CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR,
    // PENALTY_PAYMENTS_DETAILS_START,
    // PENALTY_PAYMENTS_DETAILS_SUCCESS,
    // PENALTY_PAYMENTS_DETAILS_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    paymentsDetailsData: {},
    completePaymentsDetailsData: {},
    cancelPaymentsDetailsData: {},
    //penaltyPaymentsDetailsData: {},

};
export default function TourPaymentDetailsReducer(state = { ...initialState }, action) {
    switch (action.type) {
        // case PENALTY_PAYMENTS_DETAILS_START:
        //     return {
        //         ...state,
        //         loading: true,
        //     };
        // case PENALTY_PAYMENTS_DETAILS_SUCCESS:
        //     return {
        //         ...state,
        //         penaltyPaymentsDetailsData: action.payload,
        //         loading: false,
        //     };
        // case PENALTY_PAYMENTS_DETAILS_ERROR:
        //     return {
        //         ...state,
        //         loading: false,
        //         message: action.error.message,
        //     };
        case CANCEL_CHARGE_PAYMENTS_DETAILS_START:
            return {
                ...state,
                cancelPaymentsDetailsData: {},
                loading: true,
            };
        case CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS:
            return {
                ...state,
                cancelPaymentsDetailsData: action.payload,
                loading: false,
            };
        case CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };

        case COMPLETED_PAYMENTS_DETAILS_START:
            return {
                ...state,
                cancelPaymentsDetailsData: {},
                loading: true,
            };
        case COMPLETED_PAYMENTS_DETAILS_SUCCESS:
            return {
                ...state,
                completePaymentsDetailsData: action.payload,
                loading: false,
            };
        case COMPLETED_PAYMENTS_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };

        case PENDING_PAYMENTS_DETAILS_START:
            return {
                ...state,
                paymentsDetailsData: {},
                loading: true,
            };
        case PENDING_PAYMENTS_DETAILS_SUCCESS:
            return {
                ...state,
                paymentsDetailsData: action.payload,
                loading: false,
            };
        case PENDING_PAYMENTS_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };

        default:
            return state;
    }
}

